import React from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../images/logov3.png";
import { useMoralis } from "react-moralis";
import Moralis from "moralis";
import defaultAvatar from "../images/default-avatar.jpg";
import Popup from "reactjs-popup";
import { useHistory } from "react-router-dom";

function Topnav() {
  const history = useHistory();
  const { isAuthenticated, user } = useMoralis();
  function moralisLogin() {
    if (isMobileDevice()) {
      const dappUrl = "mmonft.gallery";
      const metamaskAppDeepLink = "https://metamask.app.link/dapp/" + dappUrl;
      history.push(metamaskAppDeepLink);
    }

    if (isAuthenticated) {
      const userAddress = user.get("ethAddress");

      document.querySelector("#connect-btn").textContent = userAddress;
      var avatar_profile_btn = document.getElementById("avatar_div");
      var myitemsMenuEntry = document.getElementById("myitems");
      avatar_profile_btn.style.display = "block";
      myitemsMenuEntry.style.display = "block";
    } else {
      Moralis.authenticate().then(function (user) {
        const userAddress = user.get("ethAddress");
        document.querySelector("#connect-btn").textContent = userAddress;
        var avatar_profile_btn = document.getElementById("avatar_div");
        var myitemsMenuEntry = document.getElementById("myitems");
        avatar_profile_btn.style.display = "block";
        myitemsMenuEntry.style.display = "block";
      });
    }
  }
  function isMobileDevice() {
    return "ontouchstart" in window || "onmsgesturechange" in window;
  }
  async function moralisLogout() {
    await Moralis.User.logOut();
    window.location.reload(true);
  }
  return (
    <div className="row">
      <div>
        <Navbar collapseOnSelect expand="sm" bg="light">
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav>
              <div className="col-md-3 logo-div">
                <Link to="/" className="navbar-brand">
                  {" "}
                  <img src={logo} alt="MMOlogo"></img>{" "}
                </Link>
              </div>
              <div className="col-md-6 menu-div">
                <ul className="navbar-nav text-right">
                  <li className="nav-item active">
                    <Link to="/">Home</Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/explore">Explore</Link>
                  </li>

                  <li className="nav-item" id="myitems">
                    <Link to="/myitems">My Items</Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-3 menu-3rd-div">
                <div className="row">
                  <div className="col-md-10 menu-btns-div">
                    <span className="menu-btn-span">
                      <Link to="/singleminter">
                        <button id="create-btn">Create</button>
                      </Link>
                    </span>
                    <span className="menu-btn-span">
                      <button id="connect-btn" onClick={moralisLogin}>
                        Connect
                      </button>{" "}
                    </span>
                  </div>

                  <div className="col-md-2 avatar-div" id="avatar_div">
                    <span className="user-profile-button">
                      <Popup
                        trigger={
                          <button
                            className="profile_menu_btn"
                            style={{
                              backgroundImage: "url(" + defaultAvatar + ")",
                              backgroundSize: "cover",
                            }}
                          ></button>
                        }
                        modal
                      >
                        <span className="popup-div">
                          <ul>
                            <li>
                              <Link to="/editprofile"> Edit Profile</Link>
                            </li>
                            <li>
                              <Link to="/myitems">My Items</Link>
                            </li>
                            <li>
                              {" "}
                              <Link onClick={moralisLogout}>Log out</Link>
                            </li>
                          </ul>
                        </span>
                      </Popup>
                    </span>
                  </div>
                </div>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Navbar>
      </div>
    </div>
  );
}

export default Topnav;
